import type { DriveStep } from 'driver.js';
import { defineStore } from 'pinia';
import { useTourStore } from './tourStore';

export const useOfficeMgmTourStore = defineStore('officeMgmTour', () => {
  const tourStore = useTourStore();

  const officeMgmTourSteps: DriveStep[] = [
    {
      element: '#office-mgm-tour-anchor',
      popover: {
        title: 'Personalliste',
        description: 'Hier kannst du dein Team einladen und Mitarbeiterprofile verwalten',
        side: 'left',
        onNextClick: () => {
          tourStore.setTourToComplete();
          tourStore.driverObject?.moveNext();
        },
      },
    },
    {
      // SearchToolbar renders the add button twice: a compact one for narrow
      // `@container/gt` widths and the `-desktop` variant that is the visible one
      // from @mobileLandscape up. Tours only start from the ≥1024px help page, so
      // target the desktop variant — the compact one is `display:none` there and
      // driver.js would highlight an invisible element.
      element: '#add-therapist-button-desktop',
      popover: {
        title: 'Personal einladen',
        description:
          'Du benötigst zum Einladen lediglich die E-Mail Adresse. Desweiteren bestimmt du die Rolle des Accounts und bei mehreren Praxisstandorten, welchem der Mitarbeiter zugewiesen werden soll.',
        side: 'top',
        onNextClick: () => {
          tourStore.driverObject?.destroy();
        },
      },
    },
  ] as const;

  return {
    officeMgmTourSteps,
  };
});
